import { Component, ElementRef, OnInit } from '@angular/core';
import { ShownRightService } from '../../../service/shown-right.service';

@Component({
  selector: 'shown-right-induxtry',
  templateUrl: './shown-right.component.html',
  styleUrls: ['./shown-right.component.scss']
})
export class ShownRightComponent implements OnInit {

  constructor(
    private elementRef: ElementRef<any>,
    private readonly shownRightService: ShownRightService
  ) { }

  ngOnInit(): void {
    this.shownRightService.addShownRight(this.elementRef.nativeElement.querySelector('#shown-right-child'));
  }

  ngOnDestroy() {
    this.shownRightService.addShownRight(null);
  }

}
